export default __webpack_public_path__ + "static/media/newLoaderOnce.bc49138c.gif";